import Vue from 'vue'
import credentials from '../../credentials.js'

const auth = {
  namespaced: true,
  state: {
    sessionData: null,
    userData: null,
    error: false,
    action: 'choose',
    emailVerification: {
      sending: false,
      pending: false
    },
    signUp: {
      errors: {
        EMAIL_EXISTS: false,
        TOO_MANY_ATTEMPTS_TRY_LATER: false
      },
      submitting: false,
      pending: false
    },
    login: {
      errors: {
        EMAIL_NOT_FOUND: false,
        INVALID_PASSWORD: false,
        USER_DISABLED: false,
      },
      submitting: false,
    },
    resetPassword: {
      errors: {
        EMAIL_NOT_FOUND: false
      },
      submitting: false,
      sent: false
    },
    extendSession: {
      submitting: false
    }
  },
  mutations: {
    // Shared
    clear(state) {
      state.error = false
      state.emailVerification.sending = false
      state.emailVerification.pending = false
      state.signUp.errors.EMAIL_EXISTS = false
      state.signUp.errors.TOO_MANY_ATTEMPTS_TRY_LATER = false
      state.signUp.submitting = false
      state.signUp.pending = false
      state.login.submitting = false
      state.login.errors.EMAIL_NOT_FOUND = false
      state.login.errors.INVALID_PASSWORD = false
      state.login.errors.USER_DISABLED = false
      state.resetPassword.errors.EMAIL_NOT_FOUND = false
      state.resetPassword.submitting = false
      state.resetPassword.sent = false
      state.extendSession.submitting = false
    },
    setSessionData(state, res) {
      state.sessionData = res.data
      const now = new Date()
      const expirationDate = new Date(now.getTime() + parseInt(res.data.expiresIn)*1000)
      state.sessionData.expirationDate = expirationDate
    },
    setUserData(state, res) {
      state.userData = res.data.users[0]
    },
    chooseBack(state) {
      state.action = 'choose'
    },
    signOut(state) {
      state.sessionData = null
      state.userData = null
    },

    // Login
    chooseLogin(state) {
      state.action = 'login'
    },
    setLoginSubmitting(state, boolean) {
      state.login.submitting = boolean
    },
    loginError(state, error) {
      let message = error.response.data.error.message
      if (message == 'EMAIL_NOT_FOUND') {
        state.login.errors.EMAIL_NOT_FOUND = true
      } else if (message == 'INVALID_PASSWORD') {
        state.login.errors.INVALID_PASSWORD = true
      } else if (message == 'USER_DISABLED') {
        state.login.errors.USER_DISABLED = true
      } else {
        console.log(error)
      }
    },

    // SignUp
    chooseSignUp(state) {
      state.action = 'signUp'
    },
    signUpNewUserError(state, error) {
      let message = error.response.data.error.message
      state.signUp.submitting = false
      if (message == 'EMAIL_EXISTS') {
        state.signUp.errors.EMAIL_EXISTS = true
      } else if (message == 'TOO_MANY_ATTEMPTS_TRY_LATER') {
        state.signup.errors.TOO_MANY_ATTEMPTS_TRY_LATER = true
      } else {
        console.log(error)
      }
    },
    setSignUpSubmitting(state, boolean) {
      state.signUp.submitting = boolean
    },
    redoSignUpNewUser(state) {
      state.action = 'choose'
      state.sessionData = null
      state.userData = null
    },

    // Verification
    setSendingVerification(state, boolean) {
      state.emailVerification.sending = boolean
    },

    // Reset Password
    chooseResetPassword(state) {
      state.action = 'resetPassword'
    },
    setResetPasswordSubmitting(state, boolean) {
      state.resetPassword.submitting = boolean
    },
    resetPasswordSent(state) {
      state.resetPassword.submitting = false
      state.resetPassword.sent = true
      setTimeout(() => {
        state.action = 'login'
        state.resetPassword.sent = false
      }, 2000)
    },
    resetPasswordError(state, error) {
      let message = error.response.data.error.message
      state.resetPassword.submitting = false
      if (message == 'EMAIL_NOT_FOUND') {
        state.resetPassword.errors.EMAIL_NOT_FOUND = true
      } else {
        console.log(error)
      }
    },

    extendSession(state, res) {
      state.sessionData.refreshToken = res.refresh_token
      state.sessionData.idToken = res.id_token
      const now = new Date()
      const expirationDate = new Date(now.getTime() + res.data.expiresIn*1000)
      state.sessionData.expiresIn = res.expires_in
      state.sessionData.expirationDate = expirationDate
    },
    setExtendSessionSubmitting(state, boolean) {
      state.extendSession.submitting = boolean
    }
  },
  actions: {
    // Shared
    setUserData(context) {
      Vue.axios.post(
        `https://www.googleapis.com/identitytoolkit/v3/relyingparty/getAccountInfo?key=${credentials.firebase.apiKey}`,
        {
          idToken: context.state.sessionData.idToken
        }
      ).then(res => {
        context.commit('setUserData', res)
      }).catch( error => {
        console.log(error)
      })
    },
    setSessionData(context, res) {
      context.commit('setSessionData', res)
    },
    chooseBack(context) {
      context.commit('chooseBack')
    },
    signOut(context) {
      context.commit('signOut')
    },

    // Login
    chooseLogin(context) {
      context.commit('chooseLogin')
    },
    login(context, data) {
      context.dispatch('clear')
      context.commit('setLoginSubmitting', true)
      Vue.axios.post(
        `https://www.googleapis.com/identitytoolkit/v3/relyingparty/verifyPassword?key=${credentials.firebase.apiKey}`,
        data
      ).then( res => {
        context.dispatch('clear')
        context.dispatch('setSessionData', res).then(() => {
          context.dispatch('setUserData')
        }).catch(error => {
          console.log(error)
        })
      }).catch( error => {
        context.dispatch('clear')
        context.commit('loginError', error)
      })
    },

    // SignUp
    chooseSignUp(context) {
      context.commit('chooseSignUp')
    },
    clear(context) {
      context.commit('clear')
    },
    signUpNewUser(context, data) {
      context.dispatch('clear')
      context.commit('setSignUpSubmitting', true)
      Vue.axios.post(
        `https://www.googleapis.com/identitytoolkit/v3/relyingparty/signupNewUser?key=${credentials.firebase.apiKey}`,
        data
      ).then(res => {
        context.dispatch('clear')
        context.dispatch('setSessionData', res).then(() => {
          context.dispatch('sendEmailVerification')
        }
        ).then(
          context.dispatch('setUserData')
        )
        context.dispatch('clear')
      }).catch(error => {
        context.dispatch('clear')
        context.commit('signUpNewUserError', error)
      })
    },

    // Verification
    sendEmailVerification(context) {
      context.dispatch('clear')
      context.commit('setSendingVerification', true)
      Vue.axios.post(
        `https://www.googleapis.com/identitytoolkit/v3/relyingparty/getOobConfirmationCode?key=${credentials.firebase.apiKey}`, {
          requestType: 'VERIFY_EMAIL',
          idToken: context.state.sessionData.idToken
        }
      ).then( () => {
        if (context.rootState.isMobile) {
          context.dispatch('persistState', null, { root: true })
        }
        setTimeout(() => {
          context.commit('setSendingVerification', false)
        }, 750)
      }
      ).catch(error => {
        setTimeout(() => {
          context.commit('setSendingVerification', false)
        }, 750)
        console.log(error)
      })
    },
    redoSignUpNewUser(context) {
      context.commit('redoSignUpNewUser')
    },

    // Reset Password
    chooseResetPassword(context) {
      context.commit('chooseResetPassword')
    },
    resetPassword(context, email) {
      context.dispatch('clear')
      context.commit('setResetPasswordSubmitting', true)
      Vue.axios.post(
        `https://www.googleapis.com/identitytoolkit/v3/relyingparty/getOobConfirmationCode?key=${credentials.firebase.apiKey}`, {
          requestType: 'PASSWORD_RESET',
          email: email
        }
      ).then(() => {
        if (context.rootState.isMobile) {
          context.dispatch('persistState', null, { root: true })
        }
        context.commit('setResetPasswordSubmitting', false)
        context.commit('resetPasswordSent')
      }).catch(error => {
        context.dispatch('clear')
        context.commit('resetPasswordError', error)
      })
    },

    // Extend Session
    extendSession(context) {
      if (context.state.sessionData && context.state.sessionData.idToken && context.state.sessionData.refreshToken) {
        const expirationDate = new Date(context.state.sessionData.expirationDate)
        if (expirationDate <= new Date()) {
          context.commit('setExtendSessionSubmitting', true)
          // Get refresh token if current token expired
          Vue.axios.post(
            `https://securetoken.googleapis.com/v1/token?key=${credentials.firebase.apiKey}`,
            {
              grant_type: 'refresh_token',
              refreshToken: context.state.sessionData.refreshToken
            }
          ).then(res => {
            context.commit('extendSession', res)
            context.commit('setExtendSessionSubmitting', false)
          }).catch( error => {
            context.commit('setExtendSessionSubmitting', false)
            context.dispatch('signOut')
            console.log(error)
          })
        }
      } else {
        context.commit('setExtendSessionSubmitting', false)
        context.dispatch('signOut')
      }
    }
  }
}

export default auth